export default "__VITE_ASSET__BXwVP1Qt__"